import { render, staticRenderFns } from "./dots_location_modal.vue?vue&type=template&id=f748e71e&scoped=true&"
import script from "./dots_location_modal.vue?vue&type=script&lang=js&"
export * from "./dots_location_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f748e71e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f748e71e')) {
      api.createRecord('f748e71e', component.options)
    } else {
      api.reload('f748e71e', component.options)
    }
    module.hot.accept("./dots_location_modal.vue?vue&type=template&id=f748e71e&scoped=true&", function () {
      api.rerender('f748e71e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/dots/location/dots_location_modal.vue"
export default component.exports